import { render, staticRenderFns } from "./FeaturebaseSso.vue?vue&type=template&id=565dd5c8"
import script from "./FeaturebaseSso.vue?vue&type=script&lang=js"
export * from "./FeaturebaseSso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports